/**
 * 应用入口 — Provider 层级
 * FluentProvider > QueryClientProvider > BrowserRouter > App
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import {
  FluentProvider,
  webLightTheme,
  Spinner,
  makeStyles,
} from '@fluentui/react-components'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { useAuthStore } from '@/store/auth'
import { GlobalToaster, ToastBridge } from '@/lib/toast'
import '@/styles/global.css'

const useStyles = makeStyles({
  splash: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column',
    gap: '12px',
  },
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
})

function Root() {
  const bootstrapped = useAuthStore((s) => s.bootstrapped)
  const bootstrap = useAuthStore((s) => s.bootstrap)
  const styles = useStyles()

  React.useEffect(() => {
    bootstrap()
  }, [bootstrap])

  if (!bootstrapped) {
    return (
      <div className={styles.splash}>
        <Spinner size="large" />
        <span>Ming-Mail 加载中...</span>
      </div>
    )
  }

  return (
    <>
      <App />
      <ToastBridge />
    </>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <FluentProvider theme={webLightTheme}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Root />
        </BrowserRouter>
        <GlobalToaster />
      </QueryClientProvider>
    </FluentProvider>
  </React.StrictMode>,
)
